import React from 'react';
import i18next from '../../../i18next';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import { statusRenderer } from '../onboardingUtils';
import { Select } from '@scuf/common';
import { IRoleResponse } from '../onboardingModels';
import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';
import { ErrorGeneric } from '../../commonUtils/useFetch';
import ViewData from '../../commonUtils/ViewData';
import { useFlags } from 'launchdarkly-react-client-sdk';

export interface IUpdateUserDetailsProps {
  panelSelectedRow: any;
  role: string;
  roleList: IRoleResponse;
  isLoadingRoleList: boolean;
  errorRoleList: ErrorGeneric | undefined;
  isRoleEditable?: (user: any) => boolean;
  handleChange: (event: any, type: string) => void;
}
export const UpdateUserDetails = (props: IUpdateUserDetailsProps) => {
  const flags = useFlags();
  const isMonitorRoleEnabled = () => {    
    return flags?.enableMonitorRole ? flags.enableMonitorRole : false;
  }
  const objectToArray = (obj: any) => {
    const keysArr = Object.keys(obj);
    return keysArr.map(key => {
      return {
        listKey: key,
        listValue: obj[key]
      };
    });
  };
  return (
    <React.Fragment>
      {props.panelSelectedRow
        ? objectToArray(props.panelSelectedRow)
            .filter(
              listElData =>
                listElData.listKey === 'firstName' ||
                listElData.listKey === 'lastName' ||
                listElData.listKey === 'email' ||
                listElData.listKey === 'phone' ||
                listElData.listKey === 'status' ||
                listElData.listKey === 'role'

            )
            .map(listElData => {
              return (
                <SplitPanelUtil.PanelListItem
                  key={listElData.listKey}
                  name={i18next.t(listElData.listKey)}
                  valueRenderer={() => (
                    <>{ 
                      listElData.listKey === 'role' && props.isRoleEditable && props.isRoleEditable(props.panelSelectedRow) ? 
                      <ViewData
                        isError={props.errorRoleList}
                        isLoading={props.isLoadingRoleList}
                        errorMessage={i18next.t('rolesError')}
                        loadingMessage={i18next.t('loadingRoles')}
                        contentRender={() => (
                          <>
                            <Select
                              placeholder={i18next.t('selectRole')}
                              value={props.role }
                              options={
                                props.roleList
                                  ? props.roleList.resources
                                  .filter(resource => !(resource.name === 'Monitor' && !isMonitorRoleEnabled()))
                                  .map(resource => {
                                      const newOption: IOption = {
                                        text: resource.name,
                                        value: resource.id
                                      };
                                      return newOption;
                                    })
                                  : []
                              }
                              onChange={e => props.handleChange(e, 'role')}
                            />
                            <br />
                          </>
                        )}
                      />
                    : <span
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {statusRenderer(listElData.listValue)}
                    <div>{listElData.listValue}</div>
                  </span>}
                  </>
                    
                  )}
                />
              );
            })
        : null}
    </React.Fragment>
  );
};
